import { Outlet } from 'react-router-dom';

import Footer from './footer';
import Header from './header';

const AppLayout = () => {
  return (
    <div className='flex min-h-screen bg-gray-5'>
      <div className='flex-1 flex flex-col overflow-hidden'>
        <Header />

        <main className='flex-1 overflow-x-hidden overflow-y-auto p-6'>
          <div className='container mx-auto'>
            <Outlet />
          </div>
        </main>

        <Footer />
      </div>
    </div>
  );
};

export default AppLayout;
